import { useState, useEffect } from "react";
import axios from "axios";
//the function to call the push server: https://github.com/Spyna/push-notification-demo/blob/master/front-end-react/src/utils/http.js

import {
  isPushNotificationSupported,
  askUserPermission,
  registerServiceWorker,
  createNotificationSubscription,
  getUserSubscription
} from "@/actions/common/push-notification";
import { API } from "@/constants/common/urls";
import { SendRequest } from "@/services/common/send-request";
//import all the function created to manage the push notifications

const pushNotificationSupported = isPushNotificationSupported();
//first thing to do: check if the push notifications are supported by the browser

export default function usePushNotifications() {
  const [userConsent, setUserConsent] = useState(typeof Notification != 'undefined' ? Notification.permission : false);
  //to manage the user consent: Notification.permission is a JavaScript native function that return the current state of the permission
  //We initialize the userConsent with that value
  const [userSubscription, setUserSubscription] = useState(null);
  //to manage the use push notification subscription
  const [pushServerSubscriptionId, setPushServerSubscriptionId] = useState();
  //to manage the push server subscription
  const [notificationError, setNotificationError] = useState(null);
  //to manage errors
  const [notificationLoading, setNotificationLoading] = useState(true);
  //to manage async actions

  useEffect(() => {
    if (pushNotificationSupported) {
      setNotificationLoading(true);
      setNotificationError(false);
      registerServiceWorker().then(() => {
        setNotificationLoading(false);
      });
    }
  }, []);
  //if the push notifications are supported, registers the service worker
  //this effect runs only the first render
  
  useEffect(() => {
    setNotificationLoading(true);
    setNotificationError(false);
    const getExixtingSubscription = async () => {
      const existingSubscription = await getUserSubscription();
      setUserSubscription(existingSubscription);
      setNotificationLoading(false);
    };
    getExixtingSubscription();
  }, []);
  //Retrieve if there is any push notification subscription for the registered service worker
  // this use effect runs only in the first render

  /**
   * define a click handler that asks the user permission,
   * it uses the setUserConsent state, to set the consent of the user
   * If the user denies the consent, an error is created with the setNotificationError hook
   */
  const onClickAskUserPermission = () => {

    setNotificationLoading(true);
    setNotificationError(false);
    askUserPermission().then(consent => {
      
      setUserConsent(consent);
      if (consent !== "granted") 
      {
        setNotificationError({
          name: "Consent denied",
          message: "You denied the consent to receive notifications",
          code: 0
        });
      }
      setNotificationLoading(false);
      onClickSusbribeToPushNotification();
    });
  };
  //

  const onClickCancelUserPermission = () => {

    setNotificationLoading(true);
    setNotificationError(false);
    setNotificationError({
                          name: "Consent denied",
                          message: "You denied the consent to receive notifications",
                          code: 0
                        });
    setNotificationLoading(false);
    onClickSusbribeToPushNotification();
  };


  /**
   * define a click handler that creates a push notification subscription.
   * Once the subscription is created, it uses the setUserSubscription hook
   */
  const onClickSusbribeToPushNotification = () => {
    setNotificationLoading(true);
    setNotificationError(false);
    createNotificationSubscription()
      .then(function(subscrition) 
      {
        setUserSubscription(subscrition);
        setNotificationLoading(false);
        onClickSendSubscriptionToPushServer(subscrition);
      })
      .catch(err => {
        console.error("Couldn't create the notification subscription", err, "name:", err.name, "message:", err.message, "code:", err.code);
        setNotificationError(err);
        setNotificationLoading(false);
      });
  };

  /**
   * define a click handler that sends the push susbcribtion to the push server.
   * Once the subscription ics created on the server, it saves the id using the hook setPushServerSubscriptionId
   */
  const onClickSendSubscriptionToPushServer = (subscrition) => {

    setNotificationLoading(true);
    setNotificationError(false);

    var body = {subscription: subscrition.toJSON() }

    axios.post(API.subscribe_notification, body, new SendRequest().setHeaderJSON() )
      .then(function(response) 
      {
        setPushServerSubscriptionId(response.id);
        setNotificationLoading(false);
      })
      .catch(err => {
        setNotificationLoading(false);
        setNotificationError(err);
      });
  };


  return {
    onClickAskUserPermission,
    onClickCancelUserPermission,
    onClickSusbribeToPushNotification,
    onClickSendSubscriptionToPushServer,
    pushServerSubscriptionId,
    userConsent,
    setUserConsent,
    pushNotificationSupported,
    userSubscription,
    notificationError,
    notificationLoading
  };
}